"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _modalPopup = _interopRequireDefault(require("britive-design-system/core/components/modal-popup"));

var _Tags = _interopRequireDefault(require("./Tags"));

var _TagMembers = _interopRequireDefault(require("./TagMembers"));

var _constants = require("../../../../../../common-widgets/approval-modal/constants");

var _actions = require("../../../../../policy/Members/actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var AddTags = function AddTags(_ref) {
  var showModal = _ref.showModal,
      onModalClose = _ref.onModalClose,
      translatedStrings = _ref.translatedStrings,
      updateSelection = _ref.updateSelection,
      selectedData = _ref.selectedData;

  var _useState = (0, _react.useState)(translatedStrings.addTags),
      _useState2 = _slicedToArray(_useState, 2),
      modalTitle = _useState2[0],
      setModalTitle = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      tagForMembers = _useState4[0],
      setTagForMembers = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedTags = _useState6[0],
      setSelectedTags = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      membersVisibility = _useState8[0],
      setMembersVisibility = _useState8[1];

  var dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(function () {
    if (tagForMembers) {
      setMembersVisibility(true);
    }
  }, [tagForMembers]);
  (0, _react.useEffect)(function () {
    setSelectedTags(selectedData);
  }, [selectedData]);

  var handleModalClose = function handleModalClose() {
    onModalClose(false);
    handleBackToTagList();
    dispatch((0, _actions.resetTagMembersRequest)());
  };

  var handleBackToTagList = function handleBackToTagList() {
    setMembersVisibility(false);
    setModalTitle(translatedStrings.addTags);
    setTagForMembers(null);
    dispatch((0, _actions.resetTagMembersRequest)());
  };

  if (!showModal) {
    return null;
  }

  var tagModalButtons = [{
    text: translatedStrings.addBtn,
    variant: _constants.adminSecretListConstants.priVariant,
    onClick: function onClick() {
      updateSelection(selectedTags);
      handleModalClose();
    },
    size: _constants.adminSecretListConstants.largeSize
  }, {
    text: translatedStrings.cancelBtn,
    variant: _constants.adminSecretListConstants.secVariant,
    onClick: handleModalClose,
    size: _constants.adminSecretListConstants.largeSize
  }];
  var membersModalButtons = [{
    text: translatedStrings.back,
    variant: _constants.adminSecretListConstants.secVariant,
    onClick: handleBackToTagList,
    size: _constants.adminSecretListConstants.largeSize
  }];
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_modalPopup.default, {
    width: '50%',
    title: modalTitle,
    onCancel: handleModalClose,
    buttons: membersVisibility ? membersModalButtons : tagModalButtons
  }, membersVisibility ? /*#__PURE__*/_react.default.createElement(_TagMembers.default, {
    tagId: tagForMembers
  }) : /*#__PURE__*/_react.default.createElement(_Tags.default, {
    selectedTags: selectedTags,
    setSelectedTags: setSelectedTags,
    setTagForMembers: setTagForMembers,
    setModalTitle: setModalTitle
  })));
};

AddTags.propTypes = {
  showModal: _propTypes.default.bool,
  onModalClose: _propTypes.default.func,
  tagData: _propTypes.default.array,
  isDataLoading: _propTypes.default.bool,
  translatedStrings: _propTypes.default.object,
  updateSelection: _propTypes.default.func,
  selectedData: _propTypes.default.array
};
var _default = AddTags;
exports.default = _default;